export default __webpack_public_path__ + "46af5297fd093ee72a880a000dbf4435.png";